// extracted by mini-css-extract-plugin
export default {"banner":"WeatherAlertBanner_banner__SrLBy","icon":"WeatherAlertBanner_icon__7me6g","text":"WeatherAlertBanner_text__u1Zrj","closeBtn":"WeatherAlertBanner_closeBtn__19TCb"};